import React from "react";
import { adminUrl, webView } from "../../../../variables/webView";
import useCurrentLocation from "../../../../hooks/useCurrentLocation";

export default function HeaderAvatar() {
  const appUser = document.getElementById("app-user");
  const { localePath } = useCurrentLocation();

  if (!appUser || webView) return null;

  const initials = appUser.dataset.initials || "";

  return (
    <a href={`${adminUrl}${localePath}/entry`} className="text-decoration-none">
      <div className="d-inline-flex align-items-center justify-content-center p-2 rounded-5 overflow-hidden bg-light-primary">
        <img
          className="me-1"
          loading="lazy"
          src="/image/header/account_circle.svg"
          width="14"
          height="14"
          alt="account"
        />
        <small>{initials}</small>
      </div>
    </a>
  );
}
